module.exports = __webpack_public_path__ + "static/media/29LTBukra-Tn.c9d74290.otf";